import { FC } from "react";
import { WalletConnect } from "../WalletConnect";

export const Header: FC = () => {
  return (
    <header className="flex items-center justify-between px-4 py-3 sm:px-6">
      <img
        src="/images/sugar-rush-wordmark.svg"
        alt="Sugar Rush"
        className="h-5 sm:h-6"
      />
      <WalletConnect />
    </header>
  );
};
